import { Fragment } from 'react';

import { getEPICExplanationStringInputs } from '@/services/myEvents.service';

const EPICExplanationWithoutTooltip = ({
  className = 'md:text-sm text-xs',
  epicParameters,
  id
}) => (
  <div
    className={className}
    id={id}
  >
    {getEPICExplanationStringInputs({
      epicParameters
    }).map(({ prefix, value }) => (
      <Fragment key={value}>
        {prefix || ''}
        <span className='font-bold italic'>{value}</span>
      </Fragment>
    ))}
  </div>
);

export default EPICExplanationWithoutTooltip;
